/**
 * Téléphone en paires de chiffres : « 0102030405 » devient « 01 02 03 04 05 ».
 *
 * Les numéros sont saisis au petit bonheur — collés ici, espacés là, parfois avec des points
 * ou des tirets. On repart donc des chiffres seuls, pour que tous s'affichent pareil quelle
 * que soit la frappe d'origine.
 *
 * Hors numéro français à dix chiffres, la saisie est rendue TELLE QUELLE : un indicatif
 * international ou un numéro court n'a pas de découpage par paires, et en inventer un le
 * rendrait plus difficile à lire, pas moins.
 */
export function formatPhone(phone) {
  if (!phone) {
    return phone
  }

  const digits = String(phone).replace(/\D/g, '')

  return digits.length === 10 ? digits.match(/../g).join(' ') : phone
}

export default formatPhone



// WEBPACK FOOTER //
// ./src/filters/phone.js